/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Week_Diet_TitleInputs */

const en_portal_week_diet_title = /** @type {(inputs: Portal_Week_Diet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diet: 2400 kcal`)
};

const pl_portal_week_diet_title = /** @type {(inputs: Portal_Week_Diet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieta: 2400 kcal`)
};

/**
* | output |
* | --- |
* | "Diet: 2400 kcal" |
*
* @param {Portal_Week_Diet_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_week_diet_title = /** @type {((inputs?: Portal_Week_Diet_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Week_Diet_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_week_diet_title(inputs)
	return en_portal_week_diet_title(inputs)
});